var DesktopBasket = function() {
    return {
        matchesRefresh: function() {
            return Ajax.getBasketMatches(
                DesktopBasket.date, MatchesTable.byleague, function(data) {
                    $('#results').html(data.html);
                    MatchesTable.filterMatches(MatchesTable.match_filter);
                    Generic.updateTimes();
                    Generic.hideProgressLoader();
                });
        },
        matchesRefreshLoop: function() {
            DesktopBasket.matchesRefresh().finally(function() {
                setTimeout(DesktopBasket.matchesRefreshLoop, 20 * 1000);
            });
        },
        init: function(byleague, date) {
            MatchesTable.init(byleague);
            DesktopBasket.date = date;
            $('.ii__om_btn').click(function() {
                var order = $(this).data('orderby');
                if (order != undefined) {
                    DesktopBasket.order_matches(order);
                }
            });
            setTimeout(DesktopBasket.matchesRefreshLoop, 20 * 1000);
        },
        order_matches: function(ord) {
            if (ord == MatchesTable.byleague) {
                return;
            }
            if (ord == 'bytime') {
                $('.ii__om_time').addClass('active blue');
                $('.ii__om_league').removeClass('active blue');
            } else {
                $('.ii__om_time').removeClass('active blue');
                $('.ii__om_league').addClass('active blue');
            }
            Generic.showProgressLoader();
            MatchesTable.store_match_ordering(ord);
            DesktopBasket.matchesRefresh();
        },
    };
}();
